import { gsap, ScrollTrigger } from "../vendor/api.js";
// Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 24597, offsets 1158:138599. Structure and names inferred from code, not screenshots.
import * as dependency98991 from "../state/cookiePreferences.js";
import { module96822 as dependency96822 } from "../vendor/dependencies.js";
dependency98991;
dependency96822.env.IS_SSR || gsap.registerPlugin(ScrollTrigger);
export { App } from "../app/App.jsx";
